import { light as baseTheme } from '@eva-design/eva';
import colors from './colors';
import mappings from './mappings';
import baseMappings from './cutover.json';
import tokens from './tokens';
import fontLoader from '../../loaders/font/font';
import latoFont from '../../fonts/Lato';
import materialCommunityIconsFont from '../../fonts/MaterialCommunityIcons';
const theme = {
    ...baseTheme,
    ...colors,
    ...tokens,
};
const loaders = [
    fontLoader(latoFont),
    fontLoader(materialCommunityIconsFont),
];
export default {
    theme,
    baseMappings,
    mappings,
    loaders,
};
//# sourceMappingURL=config.js.map